import http from '../http';
import { BasicSuccessResponse, ErrorResponse } from './common';

type EditThermostatRequest = {
  systemId: number;
  thermostatId: number;
  name: string;
  value: number;
};
type EditThermostatResponse = ErrorResponse | BasicSuccessResponse;

export const editThermostat = (req: EditThermostatRequest) => http.post<EditThermostatResponse, EditThermostatRequest>('/v3/api/edit/thermostat', req);
